var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBarChartIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M6.333 3H5a.667.667 0 0 0-.667.667V13c0 .368.299.667.667.667h1.333A.667.667 0 0 0 7 13V3.667A.667.667 0 0 0 6.333 3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M10.333 7H9a.667.667 0 0 0-.667.667V13c0 .368.299.667.667.667h1.333A.667.667 0 0 0 11 13V7.667A.667.667 0 0 0 10.333 7Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M14.333 3H13a.667.667 0 0 0-.667.667V13c0 .368.299.667.667.667h1.333A.667.667 0 0 0 15 13V3.667A.667.667 0 0 0 14.333 3Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M2.333.333H1A.667.667 0 0 0 .333 1v12c0 .368.299.667.667.667h1.333A.667.667 0 0 0 3 13V1a.667.667 0 0 0-.667-.667Z"
})));
export default SvgBarChartIconMultiColor;